import { z } from 'zod';

import { ReleaseTestDocumentTypeFilterSchema } from '@/features/stacktrace/qa-force/release-test-documents/-constants';

import { ReleaseTestDocumentTableColumns } from './-table/type';

/**
 * テストスイート詳細 > ドキュメントタブの URL search スキーマ。
 *
 * - type:        種別フィルタタブ（"ALL" + FOR_INTERNAL / FOR_EXTERNAL）
 * - freeText:    検索バー（name 部分一致）
 * - pageIndex:   0-origin ページ番号
 * - pageSize:    1 ページあたりの件数
 * - sortColumn:  ソート対象カラム
 * - orderDirection: ソート方向
 *
 * `releaseTestId` は親 lazy コンポーネントが route params から取得して
 * URL search ではなく props 経由で渡す。
 */
export const ReleaseTestDocumentTableFilterSchema = z.object({
  type: ReleaseTestDocumentTypeFilterSchema.default('ALL'),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(ReleaseTestDocumentTableColumns).optional(),
  orderDirection: z.enum(['asc', 'desc']).default('desc'),
});
